var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconRocketVfzq8Ah67M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7585F0;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E4B75C;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#DE5A5A;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#D4F4FF;}\n\t.st6{fill:#D4F4FF;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#F2DF98;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#87BF8C;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#7585F0;}\n\t.st11{fill:#EDD4B4;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:#E4B75C;}\n\t.st13{fill:#AACF9A;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:#E8C673;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:#F2DF98;}\n\t.st16{fill:#D0524E;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:#87BF8C;}\n\t.st18{fill:#AACF9A;}\n\t.st19{fill:#DE5A5A;}\n\t.st20{fill:#E8C673;}\n\t.st21{fill:#7ACBAA;}\n\t.st22{fill:#EFCDC2;}\n\t.st23{fill:#6B7DFA;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GUIDELINES"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICON_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479,493.1c1-4.5,1.5-9.2,1.5-14c0-35.1-28.4-63.5-63.5-63.5c-30.2,0-55.6,21.1-62,49.4 c-11.5-11.8-27.6-19.1-45.4-19.1c-22.6,0-42.4,11.8-53.7,29.5c-11.3-17.7-31.1-29.5-53.7-29.5c-17.8,0-33.9,7.3-45.4,19.1 c-6.4-28.3-31.7-49.4-62-49.4c-35.1,0-63.5,28.4-63.5,63.5c0,4.8,0.5,9.5,1.5,14"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 297.6,
    y1: 501.9,
    x2: 502,
    y2: 501.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10,
    y1: 501.9,
    x2: 177.7,
    y2: 501.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.8,81.6c17.9,30.6,26.2,61.7,25.5,96.5c-0.7,40.7-16.3,91.3-29.4,130.9h-60l-60.3,0 c-13.1-39.6-28.9-90.3-29.4-130.9c-0.7-34.8,7.6-65.9,25.5-96.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.8,81.6c17.9,30.6,26.2,61.7,25.5,96.5c-0.7,40.7-16.3,91.3-29.4,130.9h-60l-60.3,0 c-13.1-39.6-28.9-90.3-29.4-130.9c-0.7-34.8,7.6-65.9,25.5-96.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.8,309l-60.3,0l0,0c0,0,0,0,0,0c3.7,11.3,7.5,22.4,11,33c1.3,4.1,5.1,6.8,9.4,6.9h79.5 c4.4-0.1,8.2-2.8,9.4-6.9c3.5-10.6,7.3-21.7,11-33H256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.7,348.8c-3,4.7-4.7,10.1-4.7,15.8c0,37.2,42,54.6,42,54.6s42-17.4,42-54.6c0-5.7-1.7-11-4.7-15.8H218.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.5,309C196.5,309,196.5,309,196.5,309c-8.4-25.5-18-55.6-23.9-84.7l-5.2-0.8l-10,10 c-50,50-3.5,128.1-3.4,130.8c0.8,2.3,29.5-28.4,45.6-45.9C198.6,315.3,197.5,312.1,196.5,309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.7,233.5l-13.2-13.2c-5.8,30.3-15.8,62-24.6,88.7h0c-1.1,3.4-2.2,6.7-3.3,10 c15.5,18.4,42.8,50.4,44.5,45.3C358.2,361.6,404.4,283.2,354.7,233.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.8,81.6c-1.1,1.1-4.5,4.2-5.6,5.4c-16.5,15.9-37.3,23.8-58.5,23.8s-42-7.9-58.5-23.8 c-1.1-1.1-4.5-4.2-5.6-5.4c14.8-25.2,35.9-48.9,57.3-68.6c1.8-1.8,4.2-2.8,6.8-2.8c2.5,0,4.9,1,6.8,2.8 C284.9,32.7,305.8,56.5,320.8,81.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 256.7,
    cy: 188.5,
    r: 43.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.7,145.1c24,0,43.4,19.4,43.4,43.4s-19.4,43.4-43.4,43.4s-43.4-19.4-43.4-43.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconRocketVfzq8Ah67M);
export default __webpack_public_path__ + "static/media/reshot-icon-rocket-VFZQ8AH67M.042838e1350a5d5d36d83121c0e4ae8d.svg";
export { ForwardRef as ReactComponent };